module.exports = __webpack_public_path__ + "static/hero-cans-en-CA-b5ce593d2714b148362efb55c4394a58.png";